import FuxHTTP from "../../lib/FuxFramework/FuxHTTP";
import APIConfig from "../APIConfig";
import AuthAPI from "../AuthAPI";

const buildFormData = (payload, attachments) => {
    const formData = new FormData();
    Object.keys(payload || {}).forEach(key => {
        if (payload[key] !== undefined && payload[key] !== null) {
            formData.append(key, payload[key]);
        }
    });
    if (attachments && attachments.length) {
        attachments.forEach(file => {
            formData.append("file[]", file);
        });
    }
    return formData;
};

export const _TimeoffRequests = {
    save: (payload, attachments = []) => {
        if (attachments && attachments.length) {
            const formData = buildFormData(payload, attachments);
            formData.append('token', AuthAPI.currentUser.accessToken);

            return new Promise((resolve, reject) => {
                fetch(APIConfig.url("/modulo-hr/timeoff-requests/save"), {
                    method: "POST",
                    body: formData
                })
                    .then(response => response.json())
                    .then(json => {
                        json.status === FuxHTTP.STATUS_SUCCESS ? resolve(json.data) : reject(json.message);
                    })
                    .catch(() => reject(null));
            });
        }

        return FuxHTTP.apiPostRequestWithPromise(
            APIConfig.url("/modulo-hr/timeoff-requests/save"),
            payload,
            FuxHTTP.RESOLVE_DATA,
            FuxHTTP.REJECT_MESSAGE
        );
    },
    pagination: (id_dipendente, page = 1) => {
        return FuxHTTP.apiGetRequestWithPromise(
            APIConfig.url("/modulo-hr/timeoff-requests/pagination"),
            {
                'id_dipendente[]': id_dipendente,
                page: page,
                token: AuthAPI.currentUser.accessToken
            },
            FuxHTTP.RESOLVE_DATA,
            FuxHTTP.REJECT_MESSAGE
        );
    },
    delete: request_id => {
        return FuxHTTP.apiPostRequestWithPromise(
            APIConfig.url("/modulo-hr/timeoff-requests/delete"),
            {request_id: request_id, token: AuthAPI.currentUser.accessToken},
            FuxHTTP.RESOLVE_MESSAGE,
            FuxHTTP.REJECT_MESSAGE
        );
    }
};
